import { useMedia } from './useMedia';
import { useMemo } from 'react';
import { useProductLivePreview } from './useProductLivePreview';
import { MediaObject } from '../../../types/media';
import { DeviceSize, useWindowSize } from '../../../hooks/useWindowSize';
import { getGalleryPhotos } from 'components/PdpImageGallery/helpers';
import { useShouldDisplayEngagingImages } from '../../../hooks/splits/useShouldDisplayEngagingImages';
import { useHasTouchedLivePreviewFields } from './useHasTouchedLivePreviewFields';

export const useGalleryPhotos = (): MediaObject[] => {
  const livePreviewUrl = useProductLivePreview();
  const { photos } = useMedia();
  const { deviceSize } = useWindowSize();
  const isMobile = deviceSize === DeviceSize.SMALL;

  const hasTouchedLivePreviewFields = useHasTouchedLivePreviewFields();

  const shouldDisplayEngagingImages = useShouldDisplayEngagingImages();

  return useMemo(() =>
      getGalleryPhotos(photos, livePreviewUrl, isMobile, shouldDisplayEngagingImages, hasTouchedLivePreviewFields),
    [photos, livePreviewUrl, isMobile, shouldDisplayEngagingImages, hasTouchedLivePreviewFields]);
};
